/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminAttentionResp,
    AdminAttentionRespFromJSON,
    AdminAttentionRespToJSON,
    AdminProductAnalyticsResp,
    AdminProductAnalyticsRespFromJSON,
    AdminProductAnalyticsRespToJSON,
    AdminResolveAttentionReq,
    AdminResolveAttentionReqFromJSON,
    AdminResolveAttentionReqToJSON,
    AdminResolveAttentionResp,
    AdminResolveAttentionRespFromJSON,
    AdminResolveAttentionRespToJSON,
    AdminRunAnalyticsReq,
    AdminRunAnalyticsReqFromJSON,
    AdminRunAnalyticsReqToJSON,
    AdminRunAnalyticsResp,
    AdminRunAnalyticsRespFromJSON,
    AdminRunAnalyticsRespToJSON,
} from '../models';

import {
    AdminAnalyticsApi,
    AdminAnalyticsApiAdminDashboardAttentionRequest,
    AdminAnalyticsApiAdminProductAnalyticsRequest,
    AdminAnalyticsApiAdminResolveAttentionRequest,
    AdminAnalyticsApiAdminRunAnalyticsRequest,
    AdminAnalyticsApiAdminUnresolveAttentionRequest,
} from './AdminAnalyticsApi';

type AdminDashboardAttentionQueryOptions = UseQueryOptions<
    AdminAttentionResp,
    Array<Error>,
    AdminAttentionResp,
    ['adminDashboardAttention', AdminAnalyticsApiAdminDashboardAttentionRequest?]
>;

let useAdminDashboardAttentionQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params?: AdminAnalyticsApiAdminDashboardAttentionRequest,
          options?: AdminDashboardAttentionQueryOptions
      ) => AdminDashboardAttentionQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminDashboardAttentionQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params?: AdminAnalyticsApiAdminDashboardAttentionRequest,
        options?: AdminDashboardAttentionQueryOptions
    ) => AdminDashboardAttentionQueryOptions | undefined
) {
    useAdminDashboardAttentionQueryGlobalOptions = callback;
}

export function getAdminDashboardAttentionQueryKey(
    params?: AdminAnalyticsApiAdminDashboardAttentionRequest
): ['adminDashboardAttention', AdminAnalyticsApiAdminDashboardAttentionRequest?] {
    return params !== undefined ? ['adminDashboardAttention', params] : ['adminDashboardAttention'];
}

export function useAdminDashboardAttentionQuery(
    params?: AdminAnalyticsApiAdminDashboardAttentionRequest,
    options?: AdminDashboardAttentionQueryOptions
): UseQueryResult<AdminAttentionResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminDashboardAttentionQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminAnalyticsApi().adminDashboardAttention(params, {signal})
            ),
        {
            ...options,
            ...useAdminDashboardAttentionQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminDashboardAttentionMutationOptions = UseMutationOptions<
    AdminAttentionResp,
    Array<Error>,
    AdminAnalyticsApiAdminDashboardAttentionRequest | undefined
>;

let useAdminDashboardAttentionMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminDashboardAttentionMutationOptions
      ) => AdminDashboardAttentionMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminDashboardAttentionMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminDashboardAttentionMutationOptions
    ) => AdminDashboardAttentionMutationOptions | undefined
) {
    useAdminDashboardAttentionMutationGlobalOptions = callback;
}

export function useAdminDashboardAttentionMutation(
    options?: AdminDashboardAttentionMutationOptions
): UseMutationResult<
    AdminAttentionResp,
    Array<runtime.ApiError>,
    AdminAnalyticsApiAdminDashboardAttentionRequest | undefined
> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminAnalyticsApi().adminDashboardAttention(params)),
        {
            ...options,
            ...useAdminDashboardAttentionMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminDashboardAttentionInfiniteQueryKey(
    params?: AdminAnalyticsApiAdminDashboardAttentionRequest
): ['adminDashboardAttention-infinite', AdminAnalyticsApiAdminDashboardAttentionRequest | undefined] {
    return ['adminDashboardAttention-infinite', params];
}

export function useAdminDashboardAttentionInfiniteQuery(
    params?: AdminAnalyticsApiAdminDashboardAttentionRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminAttentionResp,
            Array<runtime.ApiError>,
            AdminAttentionResp,
            AdminAttentionResp,
            ['adminDashboardAttention-infinite', AdminAnalyticsApiAdminDashboardAttentionRequest | undefined]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminAttentionResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminDashboardAttentionInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminAnalyticsApi().adminDashboardAttention({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminProductAnalyticsQueryOptions = UseQueryOptions<
    AdminProductAnalyticsResp,
    Array<Error>,
    AdminProductAnalyticsResp,
    ['adminProductAnalytics', AdminAnalyticsApiAdminProductAnalyticsRequest]
>;

let useAdminProductAnalyticsQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminAnalyticsApiAdminProductAnalyticsRequest,
          options?: AdminProductAnalyticsQueryOptions
      ) => AdminProductAnalyticsQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminProductAnalyticsQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminAnalyticsApiAdminProductAnalyticsRequest,
        options?: AdminProductAnalyticsQueryOptions
    ) => AdminProductAnalyticsQueryOptions | undefined
) {
    useAdminProductAnalyticsQueryGlobalOptions = callback;
}

export function getAdminProductAnalyticsQueryKey(
    params: AdminAnalyticsApiAdminProductAnalyticsRequest
): ['adminProductAnalytics', AdminAnalyticsApiAdminProductAnalyticsRequest] {
    return ['adminProductAnalytics', params];
}

export function useAdminProductAnalyticsQuery(
    params: AdminAnalyticsApiAdminProductAnalyticsRequest,
    options?: AdminProductAnalyticsQueryOptions
): UseQueryResult<AdminProductAnalyticsResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminProductAnalyticsQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminAnalyticsApi().adminProductAnalytics(params, {signal})
            ),
        {
            ...options,
            ...useAdminProductAnalyticsQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminProductAnalyticsMutationOptions = UseMutationOptions<
    AdminProductAnalyticsResp,
    Array<Error>,
    AdminAnalyticsApiAdminProductAnalyticsRequest
>;

let useAdminProductAnalyticsMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminProductAnalyticsMutationOptions
      ) => AdminProductAnalyticsMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminProductAnalyticsMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminProductAnalyticsMutationOptions
    ) => AdminProductAnalyticsMutationOptions | undefined
) {
    useAdminProductAnalyticsMutationGlobalOptions = callback;
}

export function useAdminProductAnalyticsMutation(
    options?: AdminProductAnalyticsMutationOptions
): UseMutationResult<
    AdminProductAnalyticsResp,
    Array<runtime.ApiError>,
    AdminAnalyticsApiAdminProductAnalyticsRequest
> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminAnalyticsApi().adminProductAnalytics(params)),
        {
            ...options,
            ...useAdminProductAnalyticsMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminProductAnalyticsInfiniteQueryKey(
    params: AdminAnalyticsApiAdminProductAnalyticsRequest
): ['adminProductAnalytics-infinite', AdminAnalyticsApiAdminProductAnalyticsRequest] {
    return ['adminProductAnalytics-infinite', params];
}

export function useAdminProductAnalyticsInfiniteQuery(
    params: AdminAnalyticsApiAdminProductAnalyticsRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminProductAnalyticsResp,
            Array<runtime.ApiError>,
            AdminProductAnalyticsResp,
            AdminProductAnalyticsResp,
            ['adminProductAnalytics-infinite', AdminAnalyticsApiAdminProductAnalyticsRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminProductAnalyticsResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminProductAnalyticsInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminAnalyticsApi().adminProductAnalytics({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminResolveAttentionQueryOptions = UseQueryOptions<
    AdminResolveAttentionResp,
    Array<Error>,
    AdminResolveAttentionResp,
    ['adminResolveAttention', AdminAnalyticsApiAdminResolveAttentionRequest]
>;

let useAdminResolveAttentionQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminAnalyticsApiAdminResolveAttentionRequest,
          options?: AdminResolveAttentionQueryOptions
      ) => AdminResolveAttentionQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminResolveAttentionQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminAnalyticsApiAdminResolveAttentionRequest,
        options?: AdminResolveAttentionQueryOptions
    ) => AdminResolveAttentionQueryOptions | undefined
) {
    useAdminResolveAttentionQueryGlobalOptions = callback;
}

export function getAdminResolveAttentionQueryKey(
    params: AdminAnalyticsApiAdminResolveAttentionRequest
): ['adminResolveAttention', AdminAnalyticsApiAdminResolveAttentionRequest] {
    return ['adminResolveAttention', params];
}

export function useAdminResolveAttentionQuery(
    params: AdminAnalyticsApiAdminResolveAttentionRequest,
    options?: AdminResolveAttentionQueryOptions
): UseQueryResult<AdminResolveAttentionResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminResolveAttentionQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminAnalyticsApi().adminResolveAttention(params, {signal})
            ),
        {
            ...options,
            ...useAdminResolveAttentionQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminResolveAttentionMutationOptions = UseMutationOptions<
    AdminResolveAttentionResp,
    Array<Error>,
    AdminAnalyticsApiAdminResolveAttentionRequest
>;

let useAdminResolveAttentionMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminResolveAttentionMutationOptions
      ) => AdminResolveAttentionMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminResolveAttentionMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminResolveAttentionMutationOptions
    ) => AdminResolveAttentionMutationOptions | undefined
) {
    useAdminResolveAttentionMutationGlobalOptions = callback;
}

export function useAdminResolveAttentionMutation(
    options?: AdminResolveAttentionMutationOptions
): UseMutationResult<
    AdminResolveAttentionResp,
    Array<runtime.ApiError>,
    AdminAnalyticsApiAdminResolveAttentionRequest
> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminAnalyticsApi().adminResolveAttention(params)),
        {
            ...options,
            ...useAdminResolveAttentionMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminResolveAttentionInfiniteQueryKey(
    params: AdminAnalyticsApiAdminResolveAttentionRequest
): ['adminResolveAttention-infinite', AdminAnalyticsApiAdminResolveAttentionRequest] {
    return ['adminResolveAttention-infinite', params];
}

export function useAdminResolveAttentionInfiniteQuery(
    params: AdminAnalyticsApiAdminResolveAttentionRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminResolveAttentionResp,
            Array<runtime.ApiError>,
            AdminResolveAttentionResp,
            AdminResolveAttentionResp,
            ['adminResolveAttention-infinite', AdminAnalyticsApiAdminResolveAttentionRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminResolveAttentionResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminResolveAttentionInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminAnalyticsApi().adminResolveAttention({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminRunAnalyticsQueryOptions = UseQueryOptions<
    AdminRunAnalyticsResp,
    Array<Error>,
    AdminRunAnalyticsResp,
    ['adminRunAnalytics', AdminAnalyticsApiAdminRunAnalyticsRequest]
>;

let useAdminRunAnalyticsQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminAnalyticsApiAdminRunAnalyticsRequest,
          options?: AdminRunAnalyticsQueryOptions
      ) => AdminRunAnalyticsQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminRunAnalyticsQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminAnalyticsApiAdminRunAnalyticsRequest,
        options?: AdminRunAnalyticsQueryOptions
    ) => AdminRunAnalyticsQueryOptions | undefined
) {
    useAdminRunAnalyticsQueryGlobalOptions = callback;
}

export function getAdminRunAnalyticsQueryKey(
    params: AdminAnalyticsApiAdminRunAnalyticsRequest
): ['adminRunAnalytics', AdminAnalyticsApiAdminRunAnalyticsRequest] {
    return ['adminRunAnalytics', params];
}

export function useAdminRunAnalyticsQuery(
    params: AdminAnalyticsApiAdminRunAnalyticsRequest,
    options?: AdminRunAnalyticsQueryOptions
): UseQueryResult<AdminRunAnalyticsResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminRunAnalyticsQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminAnalyticsApi().adminRunAnalytics(params, {signal})),
        {
            ...options,
            ...useAdminRunAnalyticsQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminRunAnalyticsMutationOptions = UseMutationOptions<
    AdminRunAnalyticsResp,
    Array<Error>,
    AdminAnalyticsApiAdminRunAnalyticsRequest
>;

let useAdminRunAnalyticsMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminRunAnalyticsMutationOptions
      ) => AdminRunAnalyticsMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminRunAnalyticsMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminRunAnalyticsMutationOptions
    ) => AdminRunAnalyticsMutationOptions | undefined
) {
    useAdminRunAnalyticsMutationGlobalOptions = callback;
}

export function useAdminRunAnalyticsMutation(
    options?: AdminRunAnalyticsMutationOptions
): UseMutationResult<AdminRunAnalyticsResp, Array<runtime.ApiError>, AdminAnalyticsApiAdminRunAnalyticsRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminAnalyticsApi().adminRunAnalytics(params)),
        {
            ...options,
            ...useAdminRunAnalyticsMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminRunAnalyticsInfiniteQueryKey(
    params: AdminAnalyticsApiAdminRunAnalyticsRequest
): ['adminRunAnalytics-infinite', AdminAnalyticsApiAdminRunAnalyticsRequest] {
    return ['adminRunAnalytics-infinite', params];
}

export function useAdminRunAnalyticsInfiniteQuery(
    params: AdminAnalyticsApiAdminRunAnalyticsRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminRunAnalyticsResp,
            Array<runtime.ApiError>,
            AdminRunAnalyticsResp,
            AdminRunAnalyticsResp,
            ['adminRunAnalytics-infinite', AdminAnalyticsApiAdminRunAnalyticsRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminRunAnalyticsResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminRunAnalyticsInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminAnalyticsApi().adminRunAnalytics({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminUnresolveAttentionQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['adminUnresolveAttention', AdminAnalyticsApiAdminUnresolveAttentionRequest]
>;

let useAdminUnresolveAttentionQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminAnalyticsApiAdminUnresolveAttentionRequest,
          options?: AdminUnresolveAttentionQueryOptions
      ) => AdminUnresolveAttentionQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminUnresolveAttentionQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminAnalyticsApiAdminUnresolveAttentionRequest,
        options?: AdminUnresolveAttentionQueryOptions
    ) => AdminUnresolveAttentionQueryOptions | undefined
) {
    useAdminUnresolveAttentionQueryGlobalOptions = callback;
}

export function getAdminUnresolveAttentionQueryKey(
    params: AdminAnalyticsApiAdminUnresolveAttentionRequest
): ['adminUnresolveAttention', AdminAnalyticsApiAdminUnresolveAttentionRequest] {
    return ['adminUnresolveAttention', params];
}

export function useAdminUnresolveAttentionQuery(
    params: AdminAnalyticsApiAdminUnresolveAttentionRequest,
    options?: AdminUnresolveAttentionQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminUnresolveAttentionQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminAnalyticsApi().adminUnresolveAttention(params, {signal})
            ),
        {
            ...options,
            ...useAdminUnresolveAttentionQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminUnresolveAttentionMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    AdminAnalyticsApiAdminUnresolveAttentionRequest
>;

let useAdminUnresolveAttentionMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminUnresolveAttentionMutationOptions
      ) => AdminUnresolveAttentionMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminUnresolveAttentionMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminUnresolveAttentionMutationOptions
    ) => AdminUnresolveAttentionMutationOptions | undefined
) {
    useAdminUnresolveAttentionMutationGlobalOptions = callback;
}

export function useAdminUnresolveAttentionMutation(
    options?: AdminUnresolveAttentionMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, AdminAnalyticsApiAdminUnresolveAttentionRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminAnalyticsApi().adminUnresolveAttention(params)),
        {
            ...options,
            ...useAdminUnresolveAttentionMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminUnresolveAttentionInfiniteQueryKey(
    params: AdminAnalyticsApiAdminUnresolveAttentionRequest
): ['adminUnresolveAttention-infinite', AdminAnalyticsApiAdminUnresolveAttentionRequest] {
    return ['adminUnresolveAttention-infinite', params];
}

export function useAdminUnresolveAttentionInfiniteQuery(
    params: AdminAnalyticsApiAdminUnresolveAttentionRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['adminUnresolveAttention-infinite', AdminAnalyticsApiAdminUnresolveAttentionRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminUnresolveAttentionInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminAnalyticsApi().adminUnresolveAttention({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
